"use client";

import type {IPrimitiveIcon} from "@gluestack-ui/icon";
import {createIcon, PrimitiveIcon} from "@gluestack-ui/icon";
import type {VariantProps} from "@gluestack-ui/nativewind-utils";
import React from "react";

import {iconStyle} from "./styles";

// TODO: temporarily disable the part ` React.RefAttributes<Svg>`
export const UIIcon = createIcon<IPrimitiveIcon>({
    Root: PrimitiveIcon
});

export const Icon = React.forwardRef<
    React.ComponentRef<typeof UIIcon>,
    React.ComponentPropsWithoutRef<typeof UIIcon> &
        VariantProps<typeof iconStyle> & {
            height?: number | string;
            width?: number | string;
        }
>(function Icon({size = "md", color, fill, stroke, className, ...props}, ref) {
    if (typeof size === "number") {
        return (
            <UIIcon ref={ref} {...props} className={iconStyle({class: className})} size={size} />
        );
    }
    if ((props.height !== undefined || props.width !== undefined) && size === undefined) {
        return <UIIcon ref={ref} {...props} className={iconStyle({class: className})} />;
    }
    return (
        <UIIcon
            ref={ref}
            {...props}
            className={iconStyle({size, color, fill, stroke, class: className})}
        />
    );
});

type ParameterTypes = Parameters<typeof createIcon>[0];

const accessClassName = (style: any) => {
    const styleObject = Array.isArray(style) ? style[0] : style;
    const keys = styleObject && Object.keys(styleObject);
    return keys ? styleObject[keys[1]] : undefined;
};

export type IIConProps = IPrimitiveIcon &
    VariantProps<typeof iconStyle> &
    React.ComponentPropsWithoutRef<typeof UIIcon>;

const createIconUI = ({...props}: ParameterTypes) => {
    const NewUIIcon = createIcon({
        // Root: Svg,
        ...props
    });
    return React.forwardRef<
        React.ComponentRef<typeof UIIcon>,
        React.ComponentPropsWithoutRef<typeof UIIcon> &
            VariantProps<typeof iconStyle> & {
                height?: number | string;
                width?: number | string;
            }
    >(function IconCreation({className, fill, size, ...inComingprops}, ref) {
        // supported cases:
        // the case using icon only: `<PaperPlaneIcon size="md" fill="primary.600" />`
        // the case inside `Icon`: `<Icon as={PaperPlaneIcon} fill="primary.600" />` <- this no longer works
        // <ButtonIcon as={PaperPlaneIcon} />

        const calculateClassName = React.useMemo(() => {
            if (inComingprops?.style) {
                return accessClassName(inComingprops.style);
            }

            return className === undefined ? accessClassName(inComingprops?.style) : className;
        }, [className, inComingprops]);

        return (
            <NewUIIcon
                ref={ref}
                // TODO: verify why it append the wrong inline style
                // {...inComingprops}
                className={calculateClassName}
            />
        );
    });
};

export {createIconUI as createIcon};
